import { useState } from "react";

const useToggleState = (initialState: any) => {
  const [state, setState] = useState(initialState);

  const toggleState = (value: string) => {
    switch (value) {
      case "Password":
        setState({ ...state, password: !state.password });
        break;
      case "confirmPassword":
        setState({ ...state, confirmPassword: !state.confirmPassword });

        break;
      case "showCriteria":
        setState({ ...state, passCriteria: true });
        break;
      case "hideCriteria":
        setState({ ...state, passCriteria: false });
        break;

      default:
    }
  };

  return [state, toggleState];
};
export default useToggleState;
